export const ProBatteryIcon=(props)=>{
    return(
        <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 100"><path fill={props.fill}  d="m232.75,0H19.31v33.35H0v30.8h19.31v33.35h224.94V0h-11.49ZM30.8,86V11.49h166.34l-74.51,74.51H30.8Zm201.96,0h-99.96L207.3,11.49h25.45v74.51Z"/></svg>
    )}